// https://git.xiaojukeji.com/BusinessAccessSecurity/frontend/Web/wsgsdk/blob/master/README.md
export default {
  online: {
    appId: '02051000',
    env: 'AME', // test：测试环境；RUS：俄罗斯；AME：美东；CN：国内环境；G：不明地区时候默认域名；
    uid: '', // 650911322282521线上加白灰度放量需要，测试环境可不传
    // interceptUrls: [
    //   'https://c.didi-food.com/entregabusiness/addAccount', // 创建商户信息
    //   'https://c.didi-food.com/entregabusiness/updateAccount', // 更新商户信息
    //   'https://c.didi-food.com/entregabusiness/billInfo', // 提单
    //   'https://c.didi-food.com/entregabusiness/createOrder', // 发单
    //   'https://c.didi-food.com/entregabusiness/textListSearch', // 批量获取地址POI信息
    // ],
    domainList: ['c.didi-food.com'], // 挑战应答
  },
};
